import { Component, Input } from "@angular/core";
import { CommentObj } from "../../interfaces/comment-obj";
import { RatingStarComponent } from "../rating-star/rating-star.component";
import { DatePipe } from "@angular/common";



@Component({
    selector: 'app-card-review',
    templateUrl: './card-review.component.html',
    styleUrls: ['./card-review.component.scss'],
    imports: [RatingStarComponent, DatePipe]
})

export class CardReviewComponent {
    @Input() comment: CommentObj;
    constructor() {
        this.comment = {} as CommentObj;
    }
 }

